var url = window.location.href;

statusPage(url);
    
function statusPage(url) {
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    http.send();
    if (http.status == 404) {  
        window.location.pathname = '/collections/furniture-best-sellers';
    }
}